if (!window.EcoScentServicesTabs) {
  window.EcoScentServicesTabs = {
    sectionSelector: '.services-tabs-section',
    tabSelector: '.services-tabs-tab',
    panelSelector: '.services-tabs-panel',

    selectTab: function (section, tab) {
      const namespace = window.EcoScentServicesTabs;

      section.querySelectorAll(namespace.tabSelector).forEach(function (otherTab) {
        otherTab.classList.remove('is-active');
        otherTab.setAttribute('aria-selected', 'false');
      });
      section.querySelectorAll(namespace.panelSelector).forEach(function (panel) {
        panel.classList.remove('is-active');
      });

      tab.classList.add('is-active');
      tab.setAttribute('aria-selected', 'true');

      const panel = section.querySelector('[data-services-tabs-panel="' + tab.dataset.tab + '"]');
      if (panel) panel.classList.add('is-active');
    },

    handleTabClick: function (event) {
      const tab = event.currentTarget;
      const section = tab.closest(window.EcoScentServicesTabs.sectionSelector);
      if (section) window.EcoScentServicesTabs.selectTab(section, tab);
    },

    initSection: function (section) {
      const namespace = window.EcoScentServicesTabs;
      if (section.dataset.servicesTabsReady === 'true') return;
      section.dataset.servicesTabsReady = 'true';

      section.querySelectorAll(namespace.tabSelector).forEach(function (tab) {
        tab.addEventListener('click', namespace.handleTabClick);
      });
    },

    initAllSections: function (root) {
      const namespace = window.EcoScentServicesTabs;
      (root || document).querySelectorAll(namespace.sectionSelector).forEach(namespace.initSection);
    },

    handleSectionLoad: function (event) {
      window.EcoScentServicesTabs.initAllSections(event.target);
    },

    listen: function () {
      const namespace = window.EcoScentServicesTabs;
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () { namespace.initAllSections(); });
      } else {
        namespace.initAllSections();
      }
      document.addEventListener('shopify:section:load', namespace.handleSectionLoad);
    },
  };

  window.EcoScentServicesTabs.listen();
}
